import { render, staticRenderFns } from "./third_party_shop.vue?vue&type=template&id=075690e2&scoped=true"
import script from "./third_party_shop.vue?vue&type=script&lang=js"
export * from "./third_party_shop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075690e2",
  null
  
)

export default component.exports